export default __webpack_public_path__ + "static/media/arror.618ce9a0.svg";